// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__WtZfP","h2":"index_h2__WdWUs","headerContainer":"index_headerContainer__ZDnJy","tabs":"index_tabs__NZFQV","moreBtn":"index_moreBtn__zkzzY"};